import { transliterateChar } from "../util/Transliteration";
import Quill from "quill";
import { addKeyboardBinding } from "../util/ui/Keyboard";
import { Counter } from "./Counter";
import { translitEnabled, translitLang } from "../SystemState";
export function createTranslitEditor(contents, cursorPosition) {
    const Block = Quill.import("blots/block");
    Block.tagName = "div";
    Quill.register(Block, true);
    const toolbar = document.getElementById("quillToolbar");
    const editor = new Quill(".quillContainer", {
        modules: { toolbar: toolbar },
        formats: ["bold", "italic", "underline", "strike", "link", "script", "list", "indent"],
        theme: "snow"
    });
    document.querySelector(".ql-container input[data-link]").dataset.link = "https://the-translit.com";
    editor.root.addEventListener("keydown", e => {
        if (e.key.length == 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
            if (transliterateChanges(editor, e.key))
                e.preventDefault();
        }
    });
    if (contents)
        editor.setContents(contents);
    editor.setSelection(cursorPosition != -1 ? cursorPosition : editor.getLength() - 1, 0);
    addKeyboardBinding({ code: "KeyE", shortKey: true }, () => editor.focus());
    new Counter(editor);
    return editor;
}
function transliterateChanges(editor, newChar) {
    const selection = editor.getSelection();
    // No transliteration if there is no selection
    if (!selection)
        return false;
    const text = editor.getText(0, selection.index) + newChar;
    const result = transliterateChar(text, translitLang.value, translitEnabled.value);
    if (!result)
        return false;
    const removedTextLength = text.length - result.removedTextIndex;
    insertText(editor, result.newLetter);
    if (removedTextLength > 1) {
        editor.deleteText(result.removedTextIndex, removedTextLength - 1);
    }
    return true;
}
export function insertText(editor, text) {
    const selection = editor.getSelection(true);
    if (selection.length != 0)
        editor.deleteText(selection.index, selection.length);
    editor.insertText(selection.index, text, editor.getFormat());
}
